import { Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import { Button } from "components/atoms/Button";
import "./index.scss";

interface SelectedBtnState {
  [key: string]: boolean;
  ViewAll: boolean;
  Coursework: boolean;
  Message: boolean;
  TestReminders: boolean;
  Surveys: boolean;
}

interface IProps {
  selectedBtn: SelectedBtnState;
  setSelectedBtn: Dispatch<SetStateAction<SelectedBtnState>>;
}

export const AlertPageFilterButtonSection = ({
  selectedBtn,
  setSelectedBtn,
}: IProps) => {
  const handleOnClick = (btnType: string) => {
    setSelectedBtn({
      ViewAll: false,
      Coursework: false,
      Message: false,
      TestReminders: false,
      Surveys: false,
      Discounts: false,
    });
    setSelectedBtn((prevSelectedBtn: SelectedBtnState) => ({
      ...prevSelectedBtn,
      [btnType.toString()]: true,
    }));
  };

  return (
    <div className={classNames("alert-filter-btn-section-wrapper")}>
      <div
        className={classNames("alert-filter-btn-section")}
        id="alert-filter-btn-section"
      >
        <Button
          label={"View All"}
          type="filter"
          isSelected={selectedBtn["ViewAll"]}
          icon={false}
          onClick={() => handleOnClick("ViewAll")}
        />
        {/* <Button
          label={"Coursework"}
          type="filter"
          isSelected={selectedBtn["Coursework"]}
          icon={false}
          onClick={() => handleOnClick("Coursework")}
        />
        <Button
          label={"Message"}
          type="filter"
          isSelected={selectedBtn["Message"]}
          icon={false}
          onClick={() => handleOnClick("Message")}
        /> */}
        <Button
          label={"Test Reminders"}
          type="filter"
          isSelected={selectedBtn["TestReminders"]}
          icon={false}
          onClick={() => handleOnClick("TestReminders")}
        />
        <Button
          label={"Surveys"}
          type="filter"
          isSelected={selectedBtn["Surveys"]}
          icon={false}
          onClick={() => handleOnClick("Surveys")}
        />
        <Button
          label={"Discounts"}
          type="filter"
          isSelected={selectedBtn["Discounts"]}
          icon={false}
          onClick={() => handleOnClick("Discounts")}
        />
      </div>
    </div>
  );
};
